import { Card } from "react-bootstrap";

import { humanizeKey } from "../utils/content.utils";
import { ObjectFieldEditor } from "./ValueEditor";

const SectionEditor = ({
  section,
  disabled = false,
  onChange,
  onUploadStart,
  onUploadEnd,
}) => {
  if (!section || typeof section !== "object") return null;

  const sectionId = section.id || "section";
  const title = humanizeKey(sectionId);

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark">
        <h5 className="mb-0 text-dark">{title}</h5>
      </Card.Header>
      <Card.Body>
        <ObjectFieldEditor
          value={section}
          disabled={disabled}
          onChange={onChange}
          onUploadStart={onUploadStart}
          onUploadEnd={onUploadEnd}
          depth={0}
          hideId
          excludeKeys={["id"]}
        />
      </Card.Body>
    </Card>
  );
};

export default SectionEditor;
